<div class="schedule-container">
  <!-- Date Navigation Header -->
  <div class="schedule-header">
    <button (click)="navigateDate(-1)" class="nav-button button-icon-only">
      <app-icon color="var(--black)" iconName="chevron-left"></app-icon>
    </button>

    <h1 class="month-title">{{ currentDateDisplay }}</h1>

    <button (click)="navigateDate(1)" class="nav-button button-icon-only">
      <app-icon color="var(--black)" iconName="chevron-right"></app-icon>
    </button>
  </div>

  <div class="schedule-grid">
    <!-- Time column -->
    @if (filteredTimeSlabs && filteredTimeSlabs.length && !isLoading) {
      <div class="time-column">
        <div class="time-header"></div>
        @for (time of filteredTimeSlabs; track time; let i = $index) {
          <div [style.height.px]="SLOT_HEIGHT" class="time-slot">
            {{ getDisplayTime(time) }}
          </div>
        }
      </div>
    }

    <!-- Loading skeleton time column -->
    @if (isLoading) {
      <div class="time-column">
        <div class="time-header"></div>
        @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
          <div [style.height.px]="SLOT_HEIGHT" class="time-slot">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '50px', height: '16px' }"></ngx-skeleton-loader>
          </div>
        }
      </div>
    }

    <!-- Loading skeleton columns -->
    @if (isLoading) {
      @for (i of [1, 2, 3, 4]; track i) {
        <div class="data-column">
          <!-- Data header skeleton -->
          <div class="data-header">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '120px', height: '16px', marginTop: '16px' }"></ngx-skeleton-loader>
          </div>
          <!-- Skeleton slots container -->
          <div class="slots-container">
            @for (j of [1, 2, 3]; track j) {
              <div class="skeleton-slot" [style.top.px]="(j - 1) * 120 + 10" [style.height.px]="100">
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '100%', height: '20px', marginBottom: '8px' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '80%', height: '16px' }"></ngx-skeleton-loader>
              </div>
            }
          </div>
        </div>
      }
    }

    <!-- Actual data columns -->
    @if (!isLoading) {
      @for (column of columns; track column) {
        <div class="data-column">
          <!-- Data header -->
          <div class="data-header">
            {{ column.title }}
          </div>
          <!-- No data message -->
          @if (!hasItemsForColumn(column.id)) {
            <div class="no-data-message">
              <div class="no-data-content">
                <app-icon color="var(--text-color-medium)" iconName="calendar"></app-icon>
                <p>{{ 'No Bookings' | translate }}</p>
              </div>
            </div>
          }
          <!-- Slots container with relative positioning -->
          @if (hasItemsForColumn(column.id)) {
            <div class="slots-container">
              <!-- Positioned time slot cards -->
              @for (item of getItemsForColumn(column.id); track item) {
                <div (click)="onSlotClick(item, column)" [class]="item.status" [style.height]="getSlotPosition(item).height" [style.top]="getSlotPosition(item).top" class="time-slot-card">
                  <!-- Booked slots -->
                  @if (item.status === 'booked') {
                    <div class="booked-slot">
                      <div class="course-name">{{ item.title }}</div>
                      <div class="slot-details">
                        <span class="slot-time">{{ getDisplayTime(item.startTime) }} - {{ getDisplayTime(item.endTime) }} {{ 'Clock' | translate }}</span>
                        @if (item.capacity) {
                          <span class="max-persons">{{ item.capacity }} Persons</span>
                        }
                      </div>
                    </div>
                  }
                  <!-- Available slots -->
                  @if (item.status === 'available') {
                    <div class="available-slot">
                      <div class="plus-icon">+</div>
                      <div class="slot-text">{{ item.title }}</div>
                      <div class="slot-time">{{ getDisplayTime(item.startTime) }} - {{ getDisplayTime(item.endTime) }}</div>
                    </div>
                  }
                  <!-- Unavailable slots -->
                  @if (item.status === 'unavailable') {
                    <div class="not-available-slot">
                      <div class="not-available-text">{{ item.title }}</div>
                      <div class="slot-time">{{ getDisplayTime(item.startTime) }} - {{ getDisplayTime(item.endTime) }}</div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>
